import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import PropTypes from 'prop-types'
import styleShape from 'react-style-proptype'

function getContainer(container) {
  const _container = typeof container === 'function' ? container() : container
  return _container instanceof HTMLElement ? _container : document.body
}

const Portal = ({ children, className = '', style, container = null }) => {
  const [mountNode, setMountNode] = useState(null)
  const overlayRef = useRef(null)

  useEffect(() => {
    const containerNode = getContainer(container)
    const div = document.createElement('div')
    if (className) div.className = className
    if (style) Object.assign(div.style, style)
    containerNode.appendChild(div)
    setMountNode(div)
    overlayRef.current = div

    return () => {
      containerNode.removeChild(div)
    }
  }, [container, className, style])

  if (mountNode === null || !children) return null

  return createPortal(children, mountNode)
}

Portal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  container: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  style: styleShape,
}

export default Portal
